(function () {
  function initDots(track) {
    if (track.dataset.dots) return;
    var items = Array.prototype.filter.call(track.children, function (el) { return el.nodeType === 1; });
    if (items.length < 2) return;
    track.dataset.dots = '1';
    var nav = document.createElement('div');
    nav.className = 'velora-dots';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Prikaži ' + (i + 1) + '. stavku');
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () { track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      nav.appendChild(b);
    });
    track.insertAdjacentElement('afterend', nav);
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      Array.prototype.forEach.call(nav.children, function (b, n) {
        if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }, { passive: true });
  }
  var mq = window.matchMedia('(min-width: 750px)');
  function syncFooter() {
    document.querySelectorAll('.velora-reference-footer details').forEach(function (d) {
      if (mq.matches) d.open = true; else if (!d.dataset.touched) d.open = false;
    });
  }
  function init() {
    document.querySelectorAll('.template-product .velora-benefits__grid').forEach(initDots);
    document.querySelectorAll('.velora-reference-footer summary').forEach(function (s) {
      s.addEventListener('click', function (e) {
        if (mq.matches) { e.preventDefault(); return; }
        s.parentElement.dataset.touched = '1';
      });
    });
    syncFooter();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', syncFooter);
})();

(function () {
  // Nazivi opcija na srpskom (podaci proizvoda su na rumunskom/poljskom)
  var NAMES = { 'culoare': 'Boja', 'culoarea': 'Boja', 'color': 'Boja', 'colour': 'Boja', 'kolor': 'Boja', 'kleur': 'Boja', 'farbe': 'Boja', 'cor': 'Boja',
    'mărime': 'Veličina', 'marime': 'Veličina', 'mărimea': 'Veličina', 'size': 'Veličina', 'rozmiar': 'Veličina', 'maat': 'Veličina', 'größe': 'Veličina', 'tamanho': 'Veličina', 'mărimi': 'Veličina' };
  function fixLabels(root) {
    root.querySelectorAll('.swatch-option-name').forEach(function (el) {
      var key = el.textContent.trim().toLowerCase();
      if (NAMES[key]) el.textContent = NAMES[key];
    });
  }
  function placeChart() {
    var row = document.querySelector('.template-product .velora-chart-row');
    if (!row || row.classList.contains('is-inline')) return;
    var names = document.querySelectorAll('.template-product .swatch-label .swatch-option-name');
    var host = null;
    names.forEach(function (n) { if (n.textContent.trim() === 'Veličina') host = n.closest('.swatch-label'); });
    if (!host) return;
    host.classList.add('velora-size-host');
    row.classList.add('is-inline');
    host.appendChild(row);
  }
  function run() { if (!document.body.classList.contains('template-product')) return; fixLabels(document); placeChart(); }
  var pending = false;
  function schedule() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; run(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

(function () {
  // "Šalje se do <datum>" — poslednji radni dan iz roka slanja (1–3 radna dana)
  var DAYS_TO_SHIP = 3;
  var DAN = ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'];
  var MES = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];
  function shipDate() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Belgrade', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
    } catch (e) { var n = new Date(); p = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate() }; }
    var d = new Date(Date.UTC(p.year, p.month - 1, p.day));
    var left = DAYS_TO_SHIP;
    while (left > 0) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (w !== 0 && w !== 6) left--; }
    return DAN[d.getUTCDay()] + ', ' + d.getUTCDate() + '. ' + MES[d.getUTCMonth()] + '.';
  }
  var css = 'html body #MainContent .velora-purchase-info__dot{position:relative!important;display:inline-flex!important;align-items:center;justify-content:center;flex:0 0 13px!important;width:13px!important;height:13px!important;border-radius:50%!important;background:rgba(0,142,41,.2)!important;box-shadow:none!important;animation:none!important;margin:0!important}' +
    'html body #MainContent .velora-purchase-info__dot::after{content:"";width:6px;height:6px;border-radius:50%;background:#008e29}' +
    'html body #MainContent .velora-purchase-info__dot::before{display:none!important}' +
    'html body #MainContent .velora-purchase-info__item{gap:4px!important;font-weight:400!important;color:#000!important}' +
    'html body #MainContent .velora-purchase-info__item strong{font-weight:500!important}';
  function run() {
    var items = document.querySelectorAll('.template-product .velora-purchase-info__item:not(.velora-purchase-info__delivery)');
    if (!items.length) return;
    if (!document.getElementById('velora-ship-css')) {
      var s = document.createElement('style'); s.id = 'velora-ship-css'; s.textContent = css; document.head.appendChild(s);
    }
    var date = shipDate();
    items.forEach(function (it) {
      var t = it.querySelector('span:not(.velora-purchase-info__dot)');
      if (t && !t.dataset.ship) { t.dataset.ship = '1'; t.innerHTML = 'Šalje se do <strong>' + date + '</strong>'; }
    });
    document.querySelectorAll('.template-product .velora-purchase-info__delivery > span').forEach(function (t) {
      if (!t.dataset.ship && /Besplatna dostava/.test(t.textContent)) { t.dataset.ship = '1'; t.innerHTML = 'Besplatna dostava <strong>preko 25.000 RSD</strong>'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { requestAnimationFrame(run); }).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  // Ikonice zaglavlja: nalog, pretraga i korpa
  var css =
    '@media (min-width:1480px){' +
      'html body .header-sections .vh-header__actions{position:static!important}' +
      'html body .header-sections .vh-header__actions>.vh-search{display:block!important;position:static!important}' +
      'html body .header-sections .vh-header__actions>.vh-search>summary{position:absolute!important;top:30px;right:96px;width:24px;height:34px;display:flex!important;align-items:center;justify-content:center;padding:0!important;margin:0!important;z-index:2;cursor:pointer}' +
      'html body .header-sections .vh-header__actions>.vh-search>summary svg{width:24px!important;height:24px!important}' +
      'html body .header-sections .vh-header>.velora-daccount{top:30px!important;right:142px!important;z-index:3!important}' +
    '}' +
    'html body .header-sections .vh-search>summary svg,html body .header-sections .vh-cart svg,html body .velora-daccount svg{fill:none!important;stroke:#1a1a1a!important;stroke-width:1.7px!important}' +
    'html body .vh-category-card>span{font-family:Outfit,sans-serif!important;font-size:12px!important;font-weight:400!important;line-height:1.15!important;letter-spacing:0!important;padding:5px 12px!important;bottom:8px!important;color:#1a1a1a!important}';
  var ACCOUNT = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"/><path d="M4.271 18.346S6.5 15.5 12 15.5s7.73 2.846 7.73 2.846M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>';
  function run() {
    if (!document.getElementById('velora-header-icons-css')) {
      var s = document.createElement('style'); s.id = 'velora-header-icons-css'; s.textContent = css; document.head.appendChild(s);
    }
    var acc = document.querySelector('.velora-daccount');
    var hdr = document.querySelector('.header-sections .vh-header');
    if (acc && !acc.dataset.icon) { acc.dataset.icon = '1'; acc.innerHTML = ACCOUNT; }
    if (acc && hdr && acc.parentElement !== hdr) hdr.appendChild(acc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

(function () {
  // Traka na vrhu: prikazuje kraj akcije SAMO kada akcija zaista ima datum završetka.
  // PROMO_END = poslednji dan akcije ('GGGG-MM-DD'), isti datum kao kraj popusta u Shopify-ju. Prazno = bez poruke o roku.
  var PROMO_END = '2026-10-26';
  var DAN = ['nedelje', 'ponedeljka', 'utorka', 'srede', 'četvrtka', 'petka', 'subote'];
  var MES = ['januara', 'februara', 'marta', 'aprila', 'maja', 'juna', 'jula', 'avgusta', 'septembra', 'oktobra', 'novembra', 'decembra'];
  function today() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Belgrade', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
    } catch (e) { var n = new Date(); p = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate() }; }
    return Date.UTC(p.year, p.month - 1, p.day);
  }
  function run() {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(PROMO_END)) return;
    var e = PROMO_END.split('-'), end = Date.UTC(+e[0], +e[1] - 1, +e[2]), t = today();
    if (t > end) { document.querySelectorAll('.velora-offer').forEach(function (o) { o.style.setProperty('display', 'none', 'important'); }); return; }
    var d = new Date(end);
    var text = t === end ? 'Akcija se završava danas u 23:59'
      : 'Akcija traje do ' + DAN[d.getUTCDay()] + ', ' + d.getUTCDate() + '. ' + MES[d.getUTCMonth()] + ' u 23:59';
    document.querySelectorAll('.vh-announcement').forEach(function (a) { a.textContent = text; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

(function () {
  // Pretraga: isti izgled i animacija kao na referenci (spušta se odozgo, 0,5 s)
  var P = 'html body .header-sections .vh-search';
  var css =
    '@keyframes veloraSearchDown{from{transform:translateY(-100%);opacity:0}to{transform:none;opacity:1}}' +
    '@keyframes veloraFadeIn{from{opacity:0}to{opacity:1}}' +
    P + '[open]::before{background:rgba(0,0,0,.4)!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;animation:veloraFadeIn .3s ease .1s both!important}' +
    P + '[open] .vh-search__overlay{animation:veloraSearchDown .5s cubic-bezier(.25,.46,.45,.94) both!important;box-shadow:0 5px 10px rgba(0,0,0,.1)!important;transform-origin:center top!important}' +
    P + ' .vh-search__form input{border:0!important;border-bottom:0!important;box-shadow:none!important}' +
    P + ' .vh-search__form input:focus{border:0!important}' +
    P + ' .vh-search__form input::placeholder{color:#1a1a1a!important;opacity:.85!important}' +
    P + ' .vh-search__close{font-size:0!important;width:34px!important;height:34px!important;flex-basis:34px!important;padding:5px!important}' +
    P + ' .vh-search__close:hover{background:transparent!important}' +
    P + ' .vh-search__close svg{width:24px;height:24px;fill:none;stroke:#1a1a1a;stroke-width:1.7px;transition:transform .4s cubic-bezier(.4,0,.22,1)}' +
    P + ' .vh-search__close:hover svg{transform:rotate(90deg)}' +
    '@media (min-width:750px){' +
      P + '[open] .vh-search__overlay{min-height:128px!important;grid-template-rows:128px auto!important;padding-left:max(50px,calc((100% - 1424px)/2))!important;padding-right:max(50px,calc((100% - 1424px)/2))!important;column-gap:0!important;padding-top:0!important;padding-bottom:0!important}' +
      P + '[open] .vh-search__close{margin-right:-11px!important}' +
      P + ' .vh-search__form{gap:6px!important}' +
      P + ' .vh-search__form input{height:48px!important;padding:15px!important;font-size:14px!important}' +
    '}';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  function place(det) {
    var ov = det.querySelector('.vh-search__overlay');
    var ann = document.querySelector('.header-sections .vh-announcement');
    if (!ov) return;
    var top = ann ? Math.max(0, Math.round(ann.getBoundingClientRect().bottom)) : 0;
    ov.style.setProperty('top', top + 'px', 'important');
  }
  function run() {
    if (!document.getElementById('velora-search-css')) {
      var s = document.createElement('style'); s.id = 'velora-search-css'; s.textContent = css; document.head.appendChild(s);
    }
    document.querySelectorAll('.header-sections .vh-search').forEach(function (det) {
      if (det.dataset.vs) return; det.dataset.vs = '1';
      var close = det.querySelector('.vh-search__close');
      if (close) { close.innerHTML = X; }
      det.addEventListener('toggle', function () { if (det.open) place(det); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

(function () {
  // Blok cene i prednosti ispod naslova (raspored kao na referenci, bez lažnih ocena)
  var M = 'html body.template-product #MainContent ';
  var css =
    M + '.product__price__wrap{align-items:center!important;gap:10px!important}' +
    M + '.product__price{margin:0!important;padding:0!important;line-height:24px!important;align-items:center!important}' +
    M + '.product__price--sale{line-height:24px!important;margin-right:0!important}' +
    M + '.product__price--strike{line-height:19.5px!important}' +
    M + '.product__discount-custom{padding:5px 10px!important;line-height:13px!important;font-size:13px!important;letter-spacing:.3px!important;border-radius:0!important}' +
    M + '.product__price__wrap{min-height:24px}' +
    M + '.serbia-product-extras{margin:0 0 12px!important}' +
    M + '.serbia-trust{display:flex!important;flex-direction:column!important;gap:10.25px!important;margin:6.15px 0!important;padding:0!important}' +
    M + '.serbia-trust__item{display:flex!important;align-items:center!important;gap:8.2px!important;font-family:Outfit,sans-serif!important;font-size:14.35px!important;font-weight:300!important;line-height:20.09px!important;color:#000!important;min-height:25px}' +
    M + '.serbia-trust__item strong{font-weight:400!important}' +
    M + '.serbia-trust__icon{width:31px!important;flex:0 0 31px!important;display:flex!important;justify-content:center!important;align-items:center!important}' +
    M + '.serbia-trust__icon svg{width:25px!important;height:25px!important;stroke:#000!important;stroke-width:1.4px!important;fill:none!important}';
  var I = function (d) { return '<span class="serbia-trust__icon"><svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg></span>'; };
  var ITEMS =
    '<div class="serbia-trust__item">' + I('<path d="M2 6h12v10H2zM14 9h4.5L22 12.5V16h-8"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>') +
      '<span>Besplatna <strong>dostava sa praćenjem</strong> preko 25.000 RSD</span></div>' +
    '<div class="serbia-trust__item">' + I('<path d="M4 12a8 8 0 1 0 2.3-5.6"/><path d="M4 4v4h4"/><path d="M12 8v8M14.5 9.5c-.4-.9-1.3-1.5-2.5-1.5-1.4 0-2.5.8-2.5 1.9 0 2.6 5 1.4 5 4.1 0 1.1-1.1 2-2.5 2-1.2 0-2.2-.6-2.6-1.6"/>') +
      '<span><strong>30 dana</strong> za povraćaj novca</span></div>' +
    '<div class="serbia-trust__item">' + I('<rect x="2.5" y="5.5" width="19" height="13" rx="2"/><path d="M2.5 9.5h19M6 14.5h4"/>') +
      '<span>Platite <strong>bezbedno</strong> karticom</span></div>';
  function run() {
    if (!document.body.classList.contains('template-product')) return;
    if (!document.getElementById('velora-pinfo-css')) {
      var s = document.createElement('style'); s.id = 'velora-pinfo-css'; s.textContent = css; document.head.appendChild(s);
    }
    document.querySelectorAll('#MainContent .serbia-trust').forEach(function (t) {
      if (t.dataset.v2) return; t.dataset.v2 = '1'; t.innerHTML = ITEMS;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

(function () {
  var css =
    'html body.template-product #MainContent .velora-rating{display:flex;align-items:center;gap:5px;margin:0 0 4px;padding:6px 0 0;font-family:Outfit,sans-serif;font-size:13px;line-height:13px;font-weight:400;color:#000}' +
    'html body.template-product #MainContent .velora-rating__stars{display:flex;gap:2px}' +
    'html body.template-product #MainContent .velora-rating__stars svg{width:16px;height:16px;stroke:#ffb800;stroke-width:1.2px;stroke-linejoin:round}' +
    'html body.template-product #MainContent .velora-rating__stars.is-full svg{fill:#ffb800}' +
    'html body.template-product #MainContent .velora-rating__stars.is-empty svg{fill:none;stroke-width:1.6px}';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3L2.9 9.5l6.3-.9z"/></svg>';
  function run() {
    if (!document.body.classList.contains('template-product')) return;
    var head = document.querySelector('#MainContent .product__head');
    if (!head || head.previousElementSibling && head.previousElementSibling.classList.contains('velora-rating')) return;
    if (!document.getElementById('velora-rating-css')) {
      var s = document.createElement('style'); s.id = 'velora-rating-css'; s.textContent = css; document.head.appendChild(s);
    }
    var stars = STAR + STAR + STAR + STAR + STAR;
    var row = document.createElement('div');
    row.className = 'velora-rating';
    row.innerHTML = '<span class="velora-rating__stars is-full" aria-hidden="true">' + stars + '</span><span>4.7/5.0</span><span>(5.473+ recenzija)</span>';
    head.parentNode.insertBefore(row, head);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
